import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-01b9e206"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "dp-sidebar"
};
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass(['dp-sidebar-box', 'with-border'])
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dp-sidebar-title"
}, " Range ", -1));
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "dp-sidebar-box"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dp-sidebar-title"
}, " Compare ", -1));
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.rangeList, item => {
    return _withDirectives((_openBlock(), _createElementBlock("div", {
      key: item.id,
      class: _normalizeClass(['dp-sidebar-item', {
        active: item.id == $props.range
      }]),
      onClick: $event => $options.onCurrentRangeChange(item.id)
    }, _toDisplayString(item.title), 11, _hoisted_4)), [[_vShow, !item.skip]]);
  }), 128))]), _createElementVNode("div", _hoisted_5, [_hoisted_6, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.compareList, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item.id,
      class: _normalizeClass(['dp-sidebar-item', {
        activeCompare: item.id == $props.compare
      }]),
      onClick: $event => $options.onCurrentCompareChange(item.id)
    }, [_createTextVNode(_toDisplayString(item.title) + " ", 1), item.subtitle ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(item.subtitle), 1)) : _createCommentVNode("", true)], 10, _hoisted_7);
  }), 128))])]);
}